/**
 * CMSText Store Module
 *
 * This module is used to get CMS text from the CMS service and make it available
 * to components.
 *
 * The store is first initialized with the action 'updateText', which gets the CMS
 * text from a given host and places that information in the store.
 *
 * To access text from the CMSText store, use the 'getCMSText' getter.
 *
 * Example:
 * export default {
 *   name: 'ExampleComponent',
 *   computed: {
 *     text() {
 *       this.$store.getters['cmsText/getCMSText']('cms:text:key', { context_variable: 'foo' });
 *     },
 *   },
 * };
 *
 *
 * You can also use the helper method 'mapGetters' to make it a little shorter:
 *
 * Example:
 * import { mapGetters } from 'vuex';
 *
 * export default {
 *   name: 'ExampleComponent',
 *   computed: {
 *     ...mapGetters('cmsText' [
 *       'getCMSText',
 *     ]),
 *     text() {
 *       this.getCMSText('cms:text:key', { context_variable: 'foo' });
 *     },
 *   },
 * };
 */

import getters from './getters';
import mutations from './mutations';
import actions from './actions';


const state = {
  text: {},
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
